import { collections } from "@/mocks/home";
import Reveal from "./Reveal";

export default function Collections() {
  return (
    <section id="collections" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs tracking-[0.3em] text-secondary-500 uppercase">
              Collections
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              往期合集打包
            </h2>
            <p className="mt-3 max-w-2xl text-sm md:text-base leading-7 text-foreground-700">
              按时间段或主题把记录打包好，一次翻完一整段，适合想慢慢回看、又不想一条条找的人。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 h-9 px-4 rounded-full bg-accent-100 text-accent-900 text-xs whitespace-nowrap">
            <i className="ri-inbox-archive-line" />
            已归档 94 个合集
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {collections.map((item, index) => (
            <Reveal
              key={item.id}
              delay={index * 70}
              className="bg-background-50 border border-background-200 rounded-lg overflow-hidden flex flex-col hover:border-primary-300 transition-colors"
            >
              <a href="#collections" className="block w-full h-40 md:h-44 cursor-pointer overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 黑料在线往期合集`}
                  className="w-full h-full object-cover object-top"
                />
              </a>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-[11px] text-foreground-500">
                  <i className="ri-calendar-line" />
                  <span className="whitespace-nowrap">{item.period}</span>
                </div>
                <h3 className="mt-3 font-heading text-base md:text-lg font-semibold text-foreground-950 leading-7">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm leading-6 text-foreground-600 flex-1">
                  {item.desc}
                </p>
                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between">
                  <span className="text-xs text-secondary-700 bg-secondary-100 px-2.5 py-1 rounded-full whitespace-nowrap">
                    共 {item.count} 条
                  </span>
                  <a
                    href="#collections"
                    className="inline-flex items-center gap-1 text-xs text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
                  >
                    查看合集
                    <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}